import CircularProgress from '@material-ui/core/CircularProgress';
import CssBaseline from '@material-ui/core/CssBaseline';
import {
  createMuiTheme,
  MuiThemeProvider,
  StylesProvider,
} from '@material-ui/core/styles';
import React, { Component, Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect, Provider } from 'unistore/full/react';
import actions from './actions';
import './App.css';
import LoginScreen from './LoginScreen';
import Main from './Main';
import store from './store';
import ScrollMemory from 'react-router-scroll-memory';

try {
  window.addEventListener('touchmove', function () {}, { passive: false });
} catch (e) {}

// FIXME: better reconnecting
// FIXME: better delete
// FIXME: clip path top gradient
// FIXME: make each assisted curation pane scroll independently
// FIXME: preview songs/click row
// FIXME: structure css
// FIXME: css replace group when context changes?!
// FIXME: get rid of withStyles?
// FIXME: touch overflow scrolling in assisted curation panes
// FIXME: close assisted curation using button
// FIXME: Login screen

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: { main: '#1db954' },
  },
});

const ConnectedApp = connect(
  ['isLoggedIn'],
  actions
)(
  class App extends Component {
    componentDidMount() {
      if (!this.props.isLoggedIn) this.props.loginWithRefreshTokenIfAvailable();
      window.addEventListener('resize', this.onResize);
      this.onResize();

      this.el = document.documentElement;
      if (!matchMedia('(hover: none)').matches) {
        this.el.addEventListener('pointerdown', this.onPointerDown);
        document.addEventListener('dragstart', this.onDragStart);
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
      this.el.removeEventListener('pointerdown', this.onPointerDown);
      document.removeEventListener('dragstart', this.onDragStart);
    }

    onDragStart = (event) => {
      event.preventDefault();
    };

    onPointerDown = (event) => {
      if (event.defaultPrevented) return;
      const el = this.el;

      const scrollTopStart = el.scrollTop;
      const startClientY = event.clientY;
      let shouldTriggerClick = true;

      const scrollToEvent = (event) => {
        const dy = startClientY - event.clientY;
        if (Math.abs(dy) > 5) shouldTriggerClick = false;
        const newScrollTop = scrollTopStart + dy;
        el.scrollTop = newScrollTop;
      };

      const onPointerMove = function (event) {
        if (event.defaultPrevented) return;
        scrollToEvent(event);
      };
      const onPointerUp = function (event) {
        if (event.defaultPrevented) return;
        scrollToEvent(event);
      };

      const onClick = (event) => {
        if (!shouldTriggerClick) {
          event.preventDefault();
          event.stopPropagation();
        }

        cleanup();
      };

      const cleanup = () => {
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        document.removeEventListener('pointercancel', cleanup);
        document.removeEventListener('click', onClick, true);
      };

      document.addEventListener('pointercancel', cleanup);
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      document.addEventListener('click', onClick, true);
    };

    onResize = () =>
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`
      );

    render() {
      const { isLoggedIn } = this.props;

      const basename = process.env.PUBLIC_URL
        ? new URL(process.env.PUBLIC_URL, global.location.href).pathname
        : undefined;

      return (
        <Router basename={basename}>
          <ScrollMemory />
          <StylesProvider injectFirst>
            <MuiThemeProvider theme={theme}>
              <CssBaseline />
              <Suspense fallback={<CircularProgress />}>
                {isLoggedIn ? (
                  <>
                    <Main />
                  </>
                ) : (
                  <LoginScreen />
                )}
              </Suspense>
            </MuiThemeProvider>
          </StylesProvider>
        </Router>
      );
    }
  }
);

export default () => (
  <Provider store={store}>
    <ConnectedApp />
  </Provider>
);
